import React from "react";
import { Select, MenuItem, FormControl, InputLabel, Typography } from "@mui/material";

interface IProps {
  last4: string;
}

const CardLast4: React.FC<IProps> = ({ last4 }) => {
  const cardNumbers = last4?.split(",");

  if (cardNumbers && cardNumbers.length > 1) {
    return (
      <td>
        <FormControl variant="outlined">
          <InputLabel>Cards</InputLabel>
          <Select value={cardNumbers[0]} label="Cards">
            {cardNumbers.map((number) => {
              return (
                <MenuItem key={number} value={number}>
                  {number}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </td>
    );
  }

  return (
    <td>
      <Typography ml="14px">{last4 === "null" ? "" : last4}</Typography>
    </td>
  );
};

export default CardLast4;
